/**
 * Утилиты строк
 */
export const bString = {
    /**
     * Возвращает true, если строка пустая
     * @param s
     */
    isEmpty(s: string): boolean {
        return s.trim() === '';
    },
    /**
     * Возвращает true, если объект строка
     * @param s
     */
    isString(s: unknown): s is string {
        return typeof s === 'string';
    },
};
/**
 * Утилиты строк
 */
export const bString = {
    /**
     * Возвращает true, если строка пустая
     * @param s
     */
    isEmpty(s: string): boolean {
        return s.trim() === '';
    },
    /**
     * Возвращает true, если объект строка
     * @param s
     */
    isString(s: unknown): s is string {
        return typeof s === 'string';
    },
};
